// extracted by mini-css-extract-plugin
module.exports = {"root":"list-item_root__zhXZZ","selected":"list-item_selected__27fFz"};